
(function () {
  'use strict';
  if (window.__mxBuscaInit) return;
  window.__mxBuscaInit = true;
  var raiz = document.querySelector('[data-mx-busca]');
  if (!raiz) return;
  function reRaiz(el) {
    var r = el && el.closest ? el.closest('[data-mx-busca]') : null;
    if (r) raiz = r;
  }
  var FATIAS = JSON.parse(raiz.getAttribute('data-fatias'));
  var dados = null, resultado = [], mostrados = 0, POR_PAG = 20,
      gradeOriginal = null, buscando = false, precoTocado = false,
      pagGuardada = [], meta = null, edMapa = {}, hMapa = {},
      tagsAtivas = {},
      marcadosPorMim = [];
  var COR = { branco: 'W', azul: 'U', preto: 'B', vermelho: 'R',
              verde: 'G' };
  var TIPO_TAG = { artefato: 'A', batalha: 'B', criatura: 'C',
                   encantamento: 'E', feitico: 'F',
                   'magica instantanea': 'I', planeswalker: 'P',
                   terreno: 'T' };
  var RAR_TAG = { comum: 'c', incomum: 'i', rara: 'r',
                  'mitica rara': 'm', especial: 'e' };

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }
  /* 17/10: a peca do caminho pode ser uma ETIQUETA DE FILTRO, e nao
     uma colecao.  /collections/all/vermelho era lido como "colecao
     chamada vermelho": o filtro exigia c[2] vazio (so' Pokemon/One
     Piece) e cortava TODA carta de Magic — buscar "raio" ali dava zero,
     enquanto em /collections/all dava 289 (defeito achado por ele em
     17/10).  Agora a etiqueta vai pelo mesmo caminho dos filtros da
     caixa, que ja' sabe ler cor, tipo, raridade e foil.
     As duas grafias valem: o caminho vem do handle da tag, e a loja
     teve "Vermelha" e "Vermelho" na mesma carta. */
  var SINONIMO_TAG = { vermelha: 'vermelho', branca: 'branco',
                       preta: 'preto', azuis: 'azul', verdes: 'verde',
                       incolores: 'incolor',
                       multicolorida: 'multicolorido' };
  /* Se a loja tiver uma COLECAO DE VERDADE com handle igual a uma
     palavra de filtro (uma gaveta "Foil", "Terrenos"...), ela manda e a
     palavra nao e' lida como etiqueta.  O conserto preenche isto
     olhando as colecoes da loja — nao e' chute. */
  var COLECAO_REAL = {};
  function etiquetaDeFiltro(peca) {
    var cru = norm(peca);
    if (COLECAO_REAL[cru]) return null;
    var t = cru.replace(/[-_]+/g, ' ').trim();
    if (SINONIMO_TAG[t]) t = SINONIMO_TAG[t];
    if (COR[t] !== undefined || TIPO_TAG[t] || RAR_TAG[t] ||
        t === 'incolor' || t === 'multicolorido' || t === 'foil') {
      return t;
    }
    return null;
  }
  function grade() {
    return document.getElementById('main-collection-product-grid');
  }
  function status(t) {
    raiz.querySelector('[data-mx-status]').textContent = t || '';
  }

  var IRRELEVANTES = ['colecoes pokemon', 'colecoes one piece',
                      'energia'];
  var ITENS_OCULTAR = ['pokemon', 'one piece', 'yu-gi-oh', 'yugioh'];
  function ocultarItensDeOutrosJogos(sim) {
    Array.prototype.forEach.call(
      document.querySelectorAll(
        '.list-tags li, .facets__item'),
      function (li) {
        if (li.closest('[data-mx-busca]')) return;
        var t = norm(li.textContent);
        for (var i = 0; i < ITENS_OCULTAR.length; i++) {
          if (t.indexOf(ITENS_OCULTAR[i]) >= 0) {
            li.style.display = sim ? 'none' : '';
            return;
          }
        }
      });
  }
  function ehIrrelevante(texto) {
    var n = norm(texto);
    for (var i = 0; i < IRRELEVANTES.length; i++) {
      if (n.indexOf(IRRELEVANTES[i]) >= 0) return true;
    }
    return false;
  }
  function ocultarIrrelevantes(sim) {
    Array.prototype.forEach.call(
      document.querySelectorAll('.sidebarBlock'),
      function (bl) {
        var h = bl.querySelector('.facets__text');
        if (!h) return;
        if (ehIrrelevante(h.textContent)) {
          bl.style.display = sim ? 'none' : '';
        }
      });
    Array.prototype.forEach.call(
      document.querySelectorAll('.widget-title'),
      function (wt) {
        var h = wt.querySelector('.sidebar-title');
        if (!h) return;
        if (ehIrrelevante(h.textContent)) {
          wt.style.display = sim ? 'none' : '';
          var cont = wt.nextElementSibling;
          if (cont && cont.classList &&
              cont.classList.contains('widget-content')) {
            cont.style.display = sim ? 'none'
              : (wt.classList.contains('open') ? '' : 'none');
          }
        }
      });
  }
  function pausarPaginacao() {
    var seletores = ['.pagination', '.pagination-wrapper',
      '.infinite-scrolling', '#AjaxinatePagination',
      '[data-load-more]', '.load-more', '.toolbar-bottom'];
    seletores.forEach(function (sel) {
      Array.prototype.forEach.call(
        document.querySelectorAll(sel), function (el) {
          if (el.getAttribute('data-mx-pausado')) return;
          el.setAttribute('data-mx-pausado', '1');
          pagGuardada.push({ el: el, pai: el.parentNode,
                             prox: el.nextSibling });
          el.parentNode.removeChild(el);
        });
    });
  }
  function retomarPaginacao() {
    pagGuardada.forEach(function (g) {
      g.el.removeAttribute('data-mx-pausado');
      if (g.prox && g.prox.parentNode === g.pai) {
        g.pai.insertBefore(g.el, g.prox);
      } else {
        g.pai.appendChild(g.el);
      }
    });
    pagGuardada = [];
  }

  function carregarMetaEd() {
    if (meta) return Promise.resolve();
    var u = raiz.getAttribute('data-arq-meta') || FATIAS[0].replace('mx-busca-0', 'mx-busca-meta');
    return fetch(u).then(function (r) { return r.json(); })
      .then(function (m) {
        meta = m;
        for (var k in m.sets) {
          var chave = norm(m.sets[k][1]);
          (edMapa[chave] = edMapa[chave] || []).push(k);
          var h = chave.replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
          (hMapa[h] = hMapa[h] || []).push(k);
        }
      }).catch(function () { meta = {}; });
  }
  function carregar() {
    if (dados) return Promise.resolve();
  carregarMetaEd();
    status('Carregando catálogo...');
    var uG = raiz.getAttribute('data-arq-g') || FATIAS[0].replace('mx-busca-0', 'mx-busca-g');
    return Promise.all(FATIAS.concat([uG]).map(function (u) {
      return fetch(u)
        .then(function (r) { return r.json(); })
        .catch(function () { return []; });
    })).then(function (partes) {
      dados = [];
      for (var i = 0; i < FATIAS.length; i++) {
        dados = dados.concat(partes[i]);
      }
      dados.forEach(function (c) {
        c.npt = norm(c[0]); c.nen = norm(c[1]);
      });
      (partes[FATIAS.length] || []).forEach(function (p) {
        // [nome, jogo, precoMin, estoque, handle] -> pseudo-carta
        var c = [p[0], p[0], '', '', '', '', '', '',
                 p[2], 0, p[3], 0, p[4], '', norm(p[1] || ''), norm(p[5] || '')];
        c.npt = norm(p[0]); c.nen = c.npt;
        dados.push(c);
      });
    });
  }

  function busca(txt) {
    var termos = [], re = /"([^"]+)"|(\S+)/g, m;
    var bruto = norm(txt);
    while ((m = re.exec(bruto))) termos.push(m[1] || m[2]);
    if (!termos.length) return [];
    /* O caminho pode vir de dois jeitos:
         /collections/quinta-edicao          -> coleção propria
         /collections/all/arena-league+mtg   -> coleção como TAG da busca
       Antes so' o primeiro pedaco era lido: em "all" o escopo ficava vazio
       e a caixa buscava a loja inteira (defeito achado por ele em 31/08).
       Agora TODAS as pecas do caminho sao julgadas, e os escopos somam. */
    var partes = window.location.pathname.split('/').filter(Boolean);
    var iCol = partes.indexOf('collections');
    var pecas = [];
    if (iCol >= 0) {
      partes.slice(iCol + 1).forEach(function (p) {
        p.split('+').forEach(function (t) {
          t = decodeURIComponent(t).replace(/\?.*$/, '');
          if (t && t !== 'all') pecas.push(t);
        });
      });
    }
    var colH = pecas.length ? pecas[0] : '';
    var escopo = null, soMagic = false, soJogo = null, soColecao = null, soColecaoH = null;
    var tagsDoCaminho = [];
    pecas.forEach(function (peca) {
      if (peca === 'magic-the-gathering' || peca === 'mtg') {
        soMagic = true;
      } else if (peca === 'one-piece-card-game' || peca === 'one-piece') {
        soJogo = 'one piece';
      } else if (peca === 'pokemon-tcg' || peca === 'pokemon') {
        soJogo = 'pokemon';
      } else if (peca === 'yu-gi-oh') {
        soJogo = 'yu';
      } else if (hMapa[peca]) {
        escopo = hMapa[peca];
      } else if (etiquetaDeFiltro(peca)) {
        tagsDoCaminho.push(etiquetaDeFiltro(peca));
      } else if (!soColecaoH) {
        soColecaoH = peca;
        if (meta && meta.cols && meta.cols[peca]) {
          soColecao = norm(meta.cols[peca]);
        }
      }
    });
    var porNome = dados.filter(function (c) {
      if (soMagic && !c[2]) return false;
      if (soJogo && (c[2] || !(c[14] && c[14].indexOf(soJogo) >= 0))) {
        return false;
      }
      if (escopo && escopo.indexOf(c[2]) < 0) return false;
        if (soColecao || soColecaoH) {
          if (c[2]) return false;
          var nomeCol = c[15] || '';
          var okCol = false;
          if (soColecao && nomeCol === soColecao) okCol = true;
          if (!okCol && soColecaoH) {
            var hCol = nomeCol.replace(/[^a-z0-9]+/g, '-')
              .replace(/^-+|-+$/g, '');
            if (hCol === soColecaoH) okCol = true;
          }
          if (!okCol) return false;
        }
      for (var i = 0; i < termos.length; i++) {
        var t = termos[i], neg = t.charAt(0) === '-';
        if (neg) t = t.slice(1);
        if (!t) continue;
        var tem = c.npt.indexOf(t) >= 0 || c.nen.indexOf(t) >= 0 ||
          (c[13] && c[13].indexOf(t) >= 0);
        if (neg ? tem : !tem) return false;
      }
      return true;
    });
    var chavesTag = Object.keys(tagsAtivas);
    tagsDoCaminho.forEach(function (t) {
      if (chavesTag.indexOf(t) < 0) chavesTag.push(t);
    });
    if (chavesTag.length) {
      porNome = porNome.filter(function (c) {
        for (var t = 0; t < chavesTag.length; t++) {
          var tg = chavesTag[t];
          if (COR[tg] !== undefined) {
            if (c[5].indexOf(COR[tg]) < 0) return false;
          } else if (tg === 'incolor') {
            if (c[5] !== '') return false;
          } else if (tg === 'multicolorido') {
            if (c[5].length < 2) return false;
          } else if (TIPO_TAG[tg]) {
            if (c[7].indexOf(TIPO_TAG[tg]) < 0) return false;
          } else if (RAR_TAG[tg]) {
            if (c[4] !== RAR_TAG[tg]) return false;
          } else if (edMapa[tg]) {
            if (edMapa[tg].indexOf(c[2]) < 0) return false;
          } else if (tg === 'foil') {
            if (!(c[9] > 0)) return false;
          } else if (tg === 'mtg' || tg === 'card') {
            if (!c[2]) return false;
          } else if (tg.indexOf('pokemon') >= 0) {
            if (!(c[14] && c[14].indexOf('pokemon') >= 0)) return false;
          } else if (tg.indexOf('one piece') >= 0) {
            if (!(c[14] && c[14].indexOf('one piece') >= 0)) return false;
          } else if (tg.indexOf('yu-gi-oh') >= 0 ||
                     tg.indexOf('yugioh') >= 0) {
            if (!(c[14] && c[14].indexOf('yu') >= 0)) return false;
          } else {
            /* neutro/desconhecida: não corta */
          }
        }
        return true;
      });
    }
    var rm = 1;
    porNome.forEach(function (c) {
      if (c[8] > rm) rm = c[8];
      if (c[9] > rm) rm = c[9];
    });
    rm = Math.ceil(rm);
    var sMin = raiz.querySelector('[data-mx-preco-smin]');
    var sMax = raiz.querySelector('[data-mx-preco-smax]');
    var iMin = raiz.querySelector('[data-mx-preco-min]');
    var iMax = raiz.querySelector('[data-mx-preco-max]');
    if (String(rm) !== sMax.getAttribute('max')) {
      sMin.max = rm; sMax.max = rm; iMin.max = rm; iMax.max = rm;
      iMax.placeholder = rm;
      if (!precoTocado) { sMin.value = 0; sMax.value = rm; }
    }
    var pMin = parseFloat(iMin.value) || 0;
    var pMax = parseFloat(iMax.value) || Infinity;
    var porPreco = porNome.filter(function (c) {
      var okN = c[8] > 0 && c[8] >= pMin && c[8] <= pMax;
      var okF = c[9] > 0 && c[9] >= pMin && c[9] <= pMax;
      return okN || okF;
    });
    var nIn = 0, nOut = 0;
    porPreco.forEach(function (c) {
      if (c[10] > 0 || c[11] > 0) nIn++; else nOut++;
    });
    raiz.querySelector('[data-mx-conta-in]').textContent =
      '(' + nIn + ')';
    raiz.querySelector('[data-mx-conta-out]').textContent =
      '(' + nOut + ')';
    var marcas = Array.prototype.map.call(
      raiz.querySelectorAll('.mxd-check:checked'),
      function (x) { return x.value; });
    var achadas = porPreco.filter(function (c) {
      if (!marcas.length || marcas.length === 2) return true;
      var emEstoque = c[10] > 0 || c[11] > 0;
      return marcas[0] === 'in' ? emEstoque : !emEstoque;
    });
    achadas.sort(function (a, b) { return a.npt < b.npt ? -1 : 1; });
    return achadas;
  }

  function buscarSub(handles, tentativa) {
    var extra = tentativa ? '&_=' + Date.now() : '';
    var url = '/search?view=mxcards&type=product&q=' +
      handles.join('+') + extra;
    return fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; })
      .then(function (html) {
        if (html && html.indexOf('data-mx-ok') >= 0) return html;
        if (!tentativa) {
          return new Promise(function (res) {
            setTimeout(function () {
              res(buscarSub(handles, 1));
            }, 400);
          });
        }
        return '';
      });
  }
  function buscarLote(handles) {
    var subs = [];
    for (var i = 0; i < handles.length; i += 5) {
      subs.push(buscarSub(handles.slice(i, i + 5), 0));
    }
    return Promise.all(subs).then(function (parts) {
      return parts.join('');
    });
  }
  var falhasRender = 0, rodape = null, fimModelo = '';
  function garantirRodape() {
    if (rodape && document.body.contains(rodape)) return rodape;
    var modelo = document.querySelector('[data-mx-rodape-modelo]');
    if (!modelo) return null;
    rodape = modelo.content.firstElementChild.cloneNode(true);
    fimModelo = rodape.querySelector('[data-mx-fim]').textContent;
    var g = grade();
    g.parentNode.insertBefore(rodape, g.nextSibling);
    rodape.querySelector('[data-mx-more-btn]')
      .addEventListener('click', mostrarPagina);
    vigiaMais.observe(rodape);
    return rodape;
  }
  function removerRodape() {
    if (rodape && rodape.parentNode) {
      rodape.parentNode.removeChild(rodape);
    }
    rodape = null;
  }
  var carregandoMais = false;
  function mostrarPagina() {
    if (carregandoMais || mostrados >= resultado.length) return;
    carregandoMais = true;
    status('Buscando cartas...');
    var g = grade();
    if (mostrados === 0) { g.innerHTML = ''; falhasRender = 0; }
    var lote = resultado.slice(mostrados, mostrados + POR_PAG)
      .map(function (c) { return c[12]; });
    mostrados += lote.length;
    buscarLote(lote).then(function (html) {
      var vieram = (html.match(/data-mx-card/g) || []).length;
      falhasRender += lote.length - vieram;
      g.insertAdjacentHTML('beforeend', html);
      status('');
      try {
      var r = garantirRodape();
      if (!r) throw 0;
      var total = resultado.length - falhasRender;
      var vistos = mostrados - falhasRender;
      r.querySelector('[data-total-end]').textContent = vistos;
      r.querySelector('[data-mx-fim]').textContent =
        fimModelo.replace('987654', total);
      r.querySelector('[data-mx-barra]').style.width =
        (total > 0 ? Math.round(vistos * 100 / total) : 100) + '%';
      var btn = r.querySelector('[data-mx-more-btn]');
      if (mostrados < resultado.length) {
        btn.classList.remove('disabled');
        btn.textContent = btn.getAttribute('data-mx-txt-more');
      } else {
        btn.classList.add('disabled');
        btn.textContent = btn.getAttribute('data-mx-txt-fim');
      }
      } catch (e) {}
      carregandoMais = false;
    });
  }
  var vigiaMais = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting && buscando) mostrarPagina();
    });
  }, { rootMargin: '400px' });

  function executar() {
    var txt = raiz.querySelector('[data-mx-input]').value.trim();
    if (!txt) return;
    Promise.all([carregar(), carregarMetaEd()]).then(function () {
      var g = grade();
      if (gradeOriginal === null) gradeOriginal = g.innerHTML;
      resultado = busca(txt);
      mostrados = 0;
      carregandoMais = false;
      buscando = true;
      raiz.querySelector('[data-mx-disp-bloco]').style.display = '';
      raiz.querySelector('[data-mx-preco-bloco]').style.display = '';
      raiz.querySelector('[data-mx-limpar]').style.display = '';
      if (!resultado.length) {
        g.innerHTML = '';
        status('Nenhuma carta encontrada.');
        raiz.querySelector('[data-mx-mais]').style.display = 'none';
        return;
      }
      pausarPaginacao();
      ocultarIrrelevantes(true);
      ocultarItensDeOutrosJogos(true);
      setTimeout(fiscais, 150);
      mostrarPagina();
    });
  }

  function limpar() {
    var g = grade();
    if (gradeOriginal !== null) g.innerHTML = gradeOriginal;
    retomarPaginacao();
    removerRodape();
    ocultarIrrelevantes(false);
    ocultarItensDeOutrosJogos(false);
    tagsAtivas = {};
    marcadosPorMim.forEach(function (cb) { cb.checked = false; });
    marcadosPorMim = [];
    raiz.querySelector('[data-mx-input]').value = '';
    raiz.querySelector('[data-mx-disp-bloco]').style.display = 'none';
    raiz.querySelector('[data-mx-preco-bloco]').style.display = 'none';
    var _i = raiz.querySelector('[data-mx-preco-min]');
    var _a = raiz.querySelector('[data-mx-preco-max]');
    _i.value = ''; _a.value = ''; precoTocado = false;
    raiz.querySelector('[data-mx-limpar]').style.display = 'none';
    raiz.querySelector('[data-mx-mais]').style.display = 'none';
    status('');
    buscando = false;
  }

  function sincPrecoDoSlider() {
    var sMin = raiz.querySelector('[data-mx-preco-smin]');
    var sMax = raiz.querySelector('[data-mx-preco-smax]');
    var a = parseInt(sMin.value, 10), b = parseInt(sMax.value, 10);
    if (a > b) { var t = a; a = b; b = t; }
    raiz.querySelector('[data-mx-preco-min]').value = a;
    raiz.querySelector('[data-mx-preco-max]').value = b;
  }
  function sincPrecoDoCampo() {
    var iMin = raiz.querySelector('[data-mx-preco-min]');
    var iMax = raiz.querySelector('[data-mx-preco-max]');
    var sMin = raiz.querySelector('[data-mx-preco-smin]');
    var sMax = raiz.querySelector('[data-mx-preco-smax]');
    var a = parseFloat(iMin.value) || 0;
    var b = parseFloat(iMax.value);
    if (!isNaN(a)) sMin.value = Math.min(a, sMin.max);
    if (!isNaN(b)) sMax.value = Math.min(b, sMax.max);
  }
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches &&
        t.matches('[data-mx-preco-smin],[data-mx-preco-smax]')) {
      reRaiz(t); precoTocado = true; sincPrecoDoSlider();
    }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-mx-preco-smin],[data-mx-preco-smax]')) {
      reRaiz(t); precoTocado = true; sincPrecoDoSlider();
      if (buscando) executar();
    } else if (t.matches('[data-mx-preco-min],[data-mx-preco-max]')) {
      reRaiz(t); precoTocado = true; sincPrecoDoCampo();
    } else if (t.matches('.mxd-check')) {
      reRaiz(t);
      if (buscando) executar();
    }
  });
  document.addEventListener('click', function (e) {
    if (!buscando) return;
    var nat = e.target.closest ?
      e.target.closest('collection-filters-form') : null;
    if (nat && !e.target.closest('[data-mx-busca]') &&
        !e.target.closest('a')) {
      var inp = e.target.closest('label') ?
        document.getElementById(
          (e.target.closest('label').getAttribute('for') || '')) :
        (e.target.matches && e.target.matches('input') ? e.target : null);
      if (inp && /availability/i.test(inp.name || '')) {
        e.preventDefault();
        e.stopPropagation();
        var querEm = String(inp.value) === '1';
        var cb = raiz.querySelector(
          '.mxd-check[value="' + (querEm ? 'in' : 'out') + '"]');
        if (cb) { cb.checked = !cb.checked; executar(); }
        return;
      }
      if (e.target.closest('input,label,.facets__reset,' +
                           '.js-facet-remove')) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
    }
    var alvo = e.target.closest ? e.target.closest('a') : null;
    if (!alvo) return;
    if (raiz.contains(alvo)) return;
    var caixaFiltros = document.getElementById(
      'main-collection-filters');
    if (!caixaFiltros || !caixaFiltros.contains(alvo)) return;
    var rotulo = norm(alvo.textContent).trim() ||
      norm(alvo.getAttribute('title') || '').trim();
    rotulo = rotulo.replace(/\s*\(\d+\)\s*$/, '').trim();
    if (!rotulo) return;
    var conhecida = (COR[rotulo] !== undefined) ||
      rotulo === 'incolor' || rotulo === 'multicolorido' ||
      TIPO_TAG[rotulo] || RAR_TAG[rotulo] || edMapa[rotulo] ||
      rotulo === 'foil' || rotulo === 'mtg' || rotulo === 'card' ||
      rotulo.indexOf('pokemon') >= 0 ||
      rotulo.indexOf('one piece') >= 0 ||
      rotulo.indexOf('yu-gi-oh') >= 0 || rotulo.indexOf('yugioh') >= 0;
    if (!conhecida) return;
    e.preventDefault();
    e.stopPropagation();
    var cb = alvo.querySelector('input[type=checkbox]');
    if (tagsAtivas[rotulo]) {
      delete tagsAtivas[rotulo];
      if (cb) cb.checked = false;
    } else {
      tagsAtivas[rotulo] = true;
      if (cb) { cb.checked = true; marcadosPorMim.push(cb); }
    }
    executar();
  }, true);
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-mx-input]') &&
        (e.key === 'Enter' || e.keyCode === 13)) {
      e.preventDefault();
      e.stopPropagation();
      reRaiz(t);
      executar();
    }
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('[data-mx-btn]');
    if (b) { reRaiz(b); executar(); return; }
    var l = t.closest('[data-mx-limpar]');
    if (l) { e.preventDefault(); reRaiz(l); limpar(); return; }
    var ap = t.closest('[data-mx-preco-aplicar]');
    if (ap) {
      reRaiz(ap); precoTocado = true; sincPrecoDoCampo();
      if (buscando) executar();
    }
  });
  function fecharGavetasTeimosas() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.widget-title'),
      function (wt) {
        var cont = wt.nextElementSibling;
        if (!cont || !cont.classList ||
            !cont.classList.contains('widget-content')) return;
        if (cont.querySelector('[data-mx-input]')) return;
        if (!wt.hasAttribute('data-mx-aberta')) {
          wt.setAttribute('data-mx-aberta',
            wt.classList.contains('open') ? '1' : '0');
        }
        var aberto = wt.getAttribute('data-mx-aberta') === '1';
        wt.classList.toggle('open', aberto);
        cont.style.display = aberto ? '' : 'none';
      });
  }
  var FISCAL_POUPA = ['disponibilidade', 'preco', 'preço',
                      'refinar por', 'buscar'];
  var ORDEM_GAVETAS_NOVA = ['refinar por', 'card game', 'buscar',
    'disponibilidade', 'preco', 'produto', 'colecoes', 'tipos',
    'cor', 'energia', 'raridade', 'acabamento', '+ filtros',
    'mais filtros', 'pre-venda', 'pré-venda'];
  function reordenarBlocos() {
    /* se o cliente esta' digitando na caixa, nao mexer nos
       blocos — mover o bloco tira o foco do campo */
    var focado = document.activeElement;
    if (focado && focado.closest &&
        focado.closest('[data-mx-busca]')) return;
    var todos = Array.prototype.slice.call(
      document.querySelectorAll('.sidebarBlock'));
    if (todos.length < 3) return;
    var contagem = new Map();
    todos.forEach(function (bl) {
      contagem.set(bl.parentNode,
        (contagem.get(bl.parentNode) || 0) + 1);
    });
    var pai = null, melhor = 0;
    contagem.forEach(function (n, p) {
      if (n > melhor) { melhor = n; pai = p; }
    });
    if (!pai || melhor < 3) return;
    var blocos = todos.filter(function (bl) {
      return bl.parentNode === pai;
    });
    var caixa = document.querySelector('[data-mx-busca]');
    if (caixa) {
      var blocoCaixa = caixa.closest('.mx-caixa') || caixa;
      if (blocoCaixa !== pai && !blocoCaixa.contains(pai) &&
          blocoCaixa.parentNode !== pai) {
        try { pai.appendChild(blocoCaixa); } catch (e) {}
      }
      if (blocos.indexOf(blocoCaixa) < 0) blocos.push(blocoCaixa);
    }
    function chave(bl) {
      if (bl.querySelector && bl.querySelector('[data-mx-input]')) {
        return ORDEM_GAVETAS_NOVA.indexOf('buscar');
      }
      var t = bl.querySelector('.facets__text');
      var n = t ? norm(t.textContent).trim() : '';
      for (var i = 0; i < ORDEM_GAVETAS_NOVA.length; i++) {
        if (n.indexOf(ORDEM_GAVETAS_NOVA[i]) >= 0) return i;
      }
      return 50;
    }
    var ordenados = blocos.slice().sort(function (x, y) {
      return chave(x) - chave(y);
    });
    var mudou = false;
    for (var k = 0; k < ordenados.length; k++) {
      if (ordenados[k] !== blocos[k]) { mudou = true; break; }
    }
    if (!mudou) return;
    ordenados.forEach(function (bl) {
  if (bl !== pai && !bl.contains(pai)) { pai.appendChild(bl); }
});
  }
  function fecharBlocosTeimosos() {
    reordenarBlocos();
    var indiceGaveta = 0;
    Array.prototype.forEach.call(
      document.querySelectorAll('.sidebarBlock'),
      function (bl) {
        if (bl.closest('[data-mx-busca]')) return;
        var h = bl.querySelector('.sidebarBlock-heading');
        var tx = bl.querySelector('.facets__text');
        if (!h || !tx) return;
        var nome = norm(tx.textContent).trim();
        for (var i = 0; i < FISCAL_POUPA.length; i++) {
          if (nome.indexOf(FISCAL_POUPA[i]) >= 0) return;
        }
        indiceGaveta++;
        var cw = bl.querySelector('.sidebarBlock-contentWrapper');
        if (cw) {
          if (!bl.hasAttribute('data-mx-aberta')) {
            bl.setAttribute('data-mx-aberta',
              indiceGaveta <= 2 ? '1' : '0');
          }
          var aberta = bl.getAttribute('data-mx-aberta') === '1';
          cw.setAttribute('data-mx-fechada', aberta ? '0' : '1');
          h.classList.toggle('is-clicked', aberta);
          if (!bl.getAttribute('data-mx-obs')) {
            bl.setAttribute('data-mx-obs', '1');
            new MutationObserver(function () {
              var ab = bl.getAttribute('data-mx-aberta') === '1';
              if (h.classList.contains('is-clicked') !== ab) {
                h.classList.toggle('is-clicked', ab);
              }
            }).observe(h, { attributes: true,
                            attributeFilter: ['class'] });
          }
          return;
        }
        var cont = bl.querySelector('.sidebarBlock-content');
        if (!cont) return;
        if (!bl.hasAttribute('data-mx-aberta')) {
          bl.setAttribute('data-mx-aberta',
            (h.classList.contains('is-clicked') ||
             indiceGaveta <= 2) ? '1' : '0');
        }
        cont.setAttribute('data-mx-fechada',
          bl.getAttribute('data-mx-aberta') === '1' ? '0' : '1');
      });
  }
  document.addEventListener('click', function (e) {
    var h = e.target.closest ?
      e.target.closest('.sidebarBlock-heading') : null;
    if (!h) return;
    var bl = h.closest('.sidebarBlock');
    if (!bl || bl.closest('[data-mx-busca]')) return;
    if (!bl.hasAttribute('data-mx-aberta')) return;
    var novo = bl.getAttribute('data-mx-aberta') === '1' ? '0' : '1';
    bl.setAttribute('data-mx-aberta', novo);
    var el = bl.querySelector('.sidebarBlock-contentWrapper') ||
      bl.querySelector('.sidebarBlock-content');
    if (el) el.setAttribute('data-mx-fechada',
      novo === '1' ? '0' : '1');
    setTimeout(function () {
      h.classList.toggle('is-clicked', novo === '1');
    }, 60);
  });
  function fiscais() {
    fecharGavetasTeimosas();
    fecharBlocosTeimosos();
  }
  fiscais();
  setTimeout(fiscais, 600);
  setTimeout(fiscais, 1800);
  setTimeout(fiscais, 3000);
  setTimeout(fiscais, 5000);
  document.addEventListener('click', function (e) {
    var sb = e.target.closest ?
      e.target.closest('.sidebarBlock-heading') : null;
    if (sb) { setTimeout(fecharBlocosTeimosos, 400); }
    var wt = e.target.closest ? e.target.closest('.widget-title') : null;
    if (!wt) return;
    if (wt.hasAttribute('data-mx-aberta')) {
      wt.setAttribute('data-mx-aberta',
        wt.getAttribute('data-mx-aberta') === '1' ? '0' : '1');
    }
    fecharGavetasTeimosas();
    setTimeout(fecharGavetasTeimosas, 350);
  });
})();
